import {z} from '@hono/zod-openapi';

export const imageGenerationBackgroundSchema = z.enum(['transparent', 'opaque']);
